<mat-dialog-content class="mat-typography" maxWidth="60vw" maxHeight="100vw">
  
    <img src="./../../assets/images/banner.png" width="100%" style="height: 100%;" alt="Quality Week"/>
  </mat-dialog-content>